import "./ToolsSection.scss";
import ToolItem from "./ToolItem";

const ToolsSection = ({ toolPlugin }) => {
  const tools = toolPlugin.mcpToolsJson
    ? JSON.parse(toolPlugin.mcpToolsJson)
    : [];

  return (
    <div className={`tools_section light_mode`}>
      <div className="tools_list">
        {tools.map((tool) => {
          return <ToolItem key={tool.name} tool={tool} />;
        })}
      </div>
    </div>
  );
};

export default ToolsSection;
